<div class="add-tax-id-container">
  <div class="add-tax-id-container__header">
    <div class="add-tax-id-container__header-title">Add tax ID</div>
    <div class="close-icon">
      <img alt="" (click)="onCancel()" src="assets/icons/x-delivery-services.svg" />
    </div>
  </div>

  <div class="text">
    <div class="add-tax-id-container__text">
      <div [formGroup]="form">
        <div class="row">
          <span class="field-label">Type</span>
          <pdq-dropdown formControlName="type" fullWidth="true" [options]="typeOptions" placeholder="Choose type">
          </pdq-dropdown>
        </div>
        <div class="row">
          <span class="field-label">Issuing authority</span>
          <pdq-dropdown
            formControlName="country"
            fullWidth="true"
            [options]="countryOptions"
            placeholder="Choose country">
          </pdq-dropdown>
        </div>
        <div class="row">
          <span class="field-label">Number</span>
          <pdq-input
            formControlName="taxId"
            placeholder="Set number"
            variant="form"
            required="true"
            [invalid]="form?.controls?.taxId?.errors?.required"
            invalidMsg="Number is required"></pdq-input>
        </div>
        <div class="row">
          <span class="field-label">Nickname</span>
          <pdq-input
            formControlName="nick"
            placeholder="Set nickname"
            variant="form"
            required="true"
            [invalid]="form?.controls?.nick?.errors?.required"
            invalidMsg="Nickname is required"></pdq-input>
        </div>
        <div class="row">
          <span class="field-label">Description (optional)</span>
          <pdq-textarea
            [control]="form.controls.description"
            placeholder="Enter description"
            maxlength="250"></pdq-textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="add-tax-id-container__actions">
    <pdq-button
      class="add-tax-id-container__actions-cancel"
      (onClick)="onCancel()"
      [label]="'Cancel'"
      [variant]="'light'">
    </pdq-button>

    <pdq-button
      class="add-tax-id-container__actions-fulfill"
      [label]="'Add tax ID'"
      (onClick)="addTaxId()"
      [variant]="'primary'">
    </pdq-button>
  </div>
</div>
